import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { api, TimbaTournamentDetail } from '../api/client';
import { getIdentity } from '../lib/identity';
import { TimbaBoard } from './TimbaBoard';

// Home de la Timba: solo el ranking global (Torneo Mundial) + acceso a "Mis torneos".
export function TimbaTournaments() {
  const pub = (() => {
    try {
      return getIdentity().pub;
    } catch {
      return '';
    }
  })();
  const [global, setGlobal] = useState<TimbaTournamentDetail | null>(null);

  useEffect(() => {
    let alive = true;
    api.timbaTournament('global').then((d) => alive && setGlobal(d)).catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return (
    <Wrap>
      <MisBtn to="/timba/torneos">🏆 Mis torneos →</MisBtn>
      {global && (
        <Board>
          <div className="head">
            <span className="nm">🌎 {global.name}</span>
            <span className="ct">{global.members} {global.members === 1 ? 'participante' : 'participantes'}</span>
          </div>
          <TimbaBoard standings={global.standings} pub={pub} top={10} />
        </Board>
      )}
    </Wrap>
  );
}

const Wrap = styled.div`
  margin-bottom: 18px;
`;

const MisBtn = styled(Link)`
  display: block;
  text-align: center;
  margin-bottom: 12px;
  padding: 11px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.surfaceAlt};
  border: 1px solid ${({ theme }) => theme.colors.borderStrong};
  color: ${({ theme }) => theme.colors.text};
  font-weight: 700;
  font-size: 0.9rem;
`;

const Board = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius};
  overflow: hidden;
  .head { display: flex; align-items: baseline; justify-content: space-between; padding: 12px 14px; background: ${({ theme }) => theme.colors.surfaceAlt}; }
  .head .nm { font-weight: 800; font-size: 1.05rem; }
  .head .ct { font-size: 0.78rem; color: ${({ theme }) => theme.colors.textMuted}; }
`;
